/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_All_RanksInputs */



/**
* | output |
* | --- |
* | "All events" |
*
* @param {Tournaments_All_RanksInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_all_ranks = /** @type {((inputs?: Tournaments_All_RanksInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_All_RanksInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les événements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los eventos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os eventos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti gli eventi")
	return /** @type {LocalizedString} */ ("All events")
});